import { RouteUrl } from './routeUrl';

export function is404(path: string) {
  const urls = Object.keys(RouteUrl);
  for (let i = 0; i < urls.length; i++) {
    const route = RouteUrl[urls[i] as keyof typeof RouteUrl];
    if (path === route) {
      return false;
    }
    // handle routes with params like /providers/edit/:id
    if (route.includes('/:')) {
      const baseRoute = route.split('/:')[0];
      if (path.startsWith(baseRoute)) {
        return false;
      }
    }
  }
  return true;
}
